export const hasToggle = (search: string, key: 'recurrence'): boolean => {
    const params = new URLSearchParams(search)
    return params.has(key)
} 